export default "__VITE_ASSET__9BgY0hpk__"